import axios from 'axios';

const instance = axios.create({
  baseURL: localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL || 'https://admin.hyprism.com/api',
});

instance.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    config.adapter = async (adapterConfig) => {
      const baseURL = adapterConfig.baseURL || '';
      let url = adapterConfig.url || '';
      if (!url.startsWith('http')) {
        url = baseURL
          ? baseURL.replace(/\/+$/, '') + '/' + url.replace(/^\/+/, '')
          : url;
      }

      // Ensure fetch sets the proper multipart boundary automatically
      // We must delete the 'Content-Type' header if it exists so `fetch` can generate its own boundary.
      const headers = { ...adapterConfig.headers };
      if (headers['Content-Type']) {
        delete headers['Content-Type'];
      }
      if (headers['content-type']) {
        delete headers['content-type'];
      }

      const response = await fetch(url, {
        method: (adapterConfig.method || 'POST').toUpperCase(),
        headers: headers,
        body: adapterConfig.data,
      });

      let data;
      const text = await response.text();
      try {
        data = JSON.parse(text);
      } catch (e) {
        data = text;
      }

      const res = {
        data,
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        config: adapterConfig,
        request: {}
      };

      if (response.ok || response.status === 200) {
        return res;
      } else {
        const error = new Error(`Request failed with status code ${response.status}`);
        error.config = adapterConfig;
        error.request = {};
        error.response = res;
        error.isAxiosError = true;
        throw error;
      }
    };
  }
  return config;
});

export default instance;
